{
  "$id": "urn:dm:schemas:css-value-definitions.schema.json",
  "title": "CSS Value Definitions",
  "description": "Individual JSON Schema definitions for CSS value types, suitable for format registration",
  "definitions": {
    "<positive-value>": {
      "type": "string",
      "pattern": "^[^-]",
      "description": "CSS positive value"
    },
    "<length>": {
      "oneOf": [
        {
          "$ref": "#/definitions/<basic-math-functions-without-percentage>"
        },
        {
          "type": "string",
          "pattern": "^(0|(-?\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))$"
        }
      ],
      "description": "CSS numeric length with all valid units"
    },
    "<positive-length>": {
      "allOf": [
        {
          "$ref": "#/definitions/<positive-value>"
        },
        {
          "$ref": "#/definitions/<length>"
        }
      ],
      "description": "CSS positive numeric length with all valid units"
    },
    "<percentage>": {
      "oneOf": [
        {
          "$ref": "#/definitions/<basic-math-functions>"
        },
        {
          "type": "string",
          "pattern": "^-?\\d*\\.?\\d+%$"
        }
      ],
      "description": "Number followed by %"
    },
    "<positive-percentage>": {
      "allOf": [
        {
          "$ref": "#/definitions/<positive-value>"
        },
        {
          "$ref": "#/definitions/<percentage>"
        }
      ],
      "description": "Positive number followed by %"
    },
    "<length-percentage>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<length>"
        },
        {
          "$ref": "#/definitions/<percentage>"
        }
      ],
      "description": "Accepts both <length> and <percentage>"
    },
    "<positive-length-percentage>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<positive-length>"
        },
        {
          "$ref": "#/definitions/<positive-percentage>"
        }
      ],
      "description": "Accepts both <positive-length> and <positive-percentage>"
    },
    "<auto>": {
      "type": "string",
      "enum": [
        "auto"
      ],
      "description": "CSS auto keyword"
    },
    "<length-percentage-auto>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<length>"
        },
        {
          "$ref": "#/definitions/<percentage>"
        },
        {
          "$ref": "#/definitions/<auto>"
        }
      ],
      "description": "CSS length, percentage, or auto"
    },
    "<positive-length-percentage-auto>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<positive-length>"
        },
        {
          "$ref": "#/definitions/<positive-percentage>"
        },
        {
          "$ref": "#/definitions/<auto>"
        }
      ],
      "description": "CSS positive length, positive percentage, or auto"
    },
    "<number>": {
      "oneOf": [
        {
          "$ref": "#/definitions/<all-math-functions-without-percentage>"
        },
        {
          "type": "string",
          "pattern": "^-?\\d*\\.?\\d+$"
        }
      ],
      "description": "Decimal or integer number"
    },
    "<positive-number>": {
      "allOf": [
        {
          "$ref": "#/definitions/<positive-value>"
        },
        {
          "$ref": "#/definitions/<number>"
        }
      ],
      "description": "Positive decimal or integer number"
    },
    "<integer>": {
      "oneOf": [
        {
          "$ref": "#/definitions/<all-math-functions-without-percentage>"
        },
        {
          "type": "string",
          "pattern": "^-?\\d+$"
        }
      ],
      "description": "Whole numbers only"
    },
    "height": {
      "anyOf": [
        {
          "$ref": "#/definitions/<auto>"
        },
        {
          "$ref": "#/definitions/<positive-length-percentage>"
        },
        {
          "type": "string",
          "enum": [
            "min-content",
            "max-content"
          ]
        }
      ],
      "description": "CSS height value"
    },
    "<angle>": {
      "oneOf": [
        {
          "$ref": "#/definitions/<all-math-functions>"
        },
        {
          "type": "string",
          "pattern": "^-?\\d*\\.?\\d+(deg|rad|grad|turn)$"
        }
      ],
      "description": "Used in rotation, direction, etc."
    },
    "<time>": {
      "oneOf": [
        {
          "$ref": "#/definitions/<basic-math-functions-without-percentage>"
        },
        {
          "type": "string",
          "pattern": "^-?\\d*\\.?\\d+(ms|s)$"
        }
      ],
      "description": "CSS durations (s, ms)"
    },
    "<resolution>": {
      "type": "string",
      "pattern": "^-?\\d*\\.?\\d+(dpi|dpcm|dppx|x)$",
      "description": "Screen density/resolution units"
    },
    "<frequency>": {
      "oneOf": [
        {
          "$ref": "#/definitions/<basic-math-functions>"
        },
        {
          "type": "string",
          "pattern": "^-?\\d*\\.?\\d+(Hz|kHz)$"
        }
      ],
      "description": "Used in aural CSS or media queries"
    },
    "<dimension>": {
      "type": "string",
      "pattern": "^-?\\d*\\.?\\d+[a-zA-Z]+$",
      "description": "Generic dimension (unit required)"
    },
    "<percentage-or-number>": {
      "oneOf": [
        {
          "$ref": "#/definitions/<number>"
        },
        {
          "$ref": "#/definitions/<percentage>"
        }
      ],
      "description": "Matches numbers or percentages"
    },
    "<custom-ident>": {
      "type": "string",
      "pattern": "^[a-zA-Z_][\\w-]*$",
      "description": "CSS identifiers (excluding keywords)"
    },
    "<ident>": {
      "type": "string",
      "pattern": "^[a-zA-Z_][\\w-]*$",
      "description": "Same as <custom-ident>"
    },
    "<string>": {
      "type": "string",
      "pattern": "^\"(?:[^\"\\\\]|\\\\.)*\"|'(?:[^'\\\\]|\\\\.)*'$",
      "description": "Quoted strings with escapes"
    },
    "<url>": {
      "type": "string",
      "pattern": "^url\\((['\"]?).*?\\1\\)$",
      "description": "Matches url(...) with optional quotes"
    },
    "<hex-color>": {
      "type": "string",
      "pattern": "^#([a-fA-F0-9]{3}|[a-fA-F0-9]{4}|[a-fA-F0-9]{6}|[a-fA-F0-9]{8})$",
      "description": "Hexadecimal color values: #rgb, #rgba, #rrggbb, #rrggbbaa"
    },
    "<rgb-color>": {
      "type": "string",
      "pattern": "^rgba?\\(\\s*\\d+\\s*,\\s*\\d+\\s*,\\s*\\d+(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
      "description": "RGB/RGBA functional notation. Note: This regex cannot fully validate percentage values or modern space-separated syntax."
    },
    "<hsl-color>": {
      "type": "string",
      "pattern": "^hsla?\\(\\s*\\d+\\s*,\\s*\\d+%\\s*,\\s*\\d+%(\\s*,\\s*\\d*(\\.\\d+)?)?\\s*\\)$",
      "description": "HSL/HSLA functional notation. Note: This regex cannot fully validate modern space-separated syntax or angle units for hue."
    },
    "<named-color>": {
      "type": "string",
      "enum": [
        "transparent",
        "currentColor",
        "aliceblue",
        "antiquewhite",
        "aqua",
        "aquamarine",
        "azure",
        "beige",
        "bisque",
        "black",
        "blanchedalmond",
        "blue",
        "blueviolet",
        "brown",
        "burlywood",
        "cadetblue",
        "chartreuse",
        "chocolate",
        "coral",
        "cornflowerblue",
        "cornsilk",
        "crimson",
        "cyan",
        "darkblue",
        "darkcyan",
        "darkgoldenrod",
        "darkgray",
        "darkgrey",
        "darkgreen",
        "darkkhaki",
        "darkmagenta",
        "darkolivegreen",
        "darkorange",
        "darkorchid",
        "darkred",
        "darksalmon",
        "darkseagreen",
        "darkslateblue",
        "darkslategray",
        "darkslategrey",
        "darkturquoise",
        "darkviolet",
        "deeppink",
        "deepskyblue",
        "dimgray",
        "dimgrey",
        "dodgerblue",
        "firebrick",
        "floralwhite",
        "forestgreen",
        "fuchsia",
        "gainsboro",
        "ghostwhite",
        "gold",
        "goldenrod",
        "gray",
        "grey",
        "green",
        "greenyellow",
        "honeydew",
        "hotpink",
        "indianred",
        "indigo",
        "ivory",
        "khaki",
        "lavender",
        "lavenderblush",
        "lawngreen",
        "lemonchiffon",
        "lightblue",
        "lightcoral",
        "lightcyan",
        "lightgoldenrodyellow",
        "lightgray",
        "lightgrey",
        "lightgreen",
        "lightpink",
        "lightsalmon",
        "lightseagreen",
        "lightskyblue",
        "lightslategray",
        "lightslategrey",
        "lightsteelblue",
        "lightyellow",
        "lime",
        "limegreen",
        "linen",
        "magenta",
        "maroon",
        "mediumaquamarine",
        "mediumblue",
        "mediumorchid",
        "mediumpurple",
        "mediumseagreen",
        "mediumslateblue",
        "mediumspringgreen",
        "mediumturquoise",
        "mediumvioletred",
        "midnightblue",
        "mintcream",
        "mistyrose",
        "moccasin",
        "navajowhite",
        "navy",
        "oldlace",
        "olive",
        "olivedrab",
        "orange",
        "orangered",
        "orchid",
        "palegoldenrod",
        "palegreen",
        "paleturquoise",
        "palevioletred",
        "papayawhip",
        "peachpuff",
        "peru",
        "pink",
        "plum",
        "powderblue",
        "purple",
        "rebeccapurple",
        "red",
        "rosybrown",
        "royalblue",
        "saddlebrown",
        "salmon",
        "sandybrown",
        "seagreen",
        "seashell",
        "sienna",
        "silver",
        "skyblue",
        "slateblue",
        "slategray",
        "slategrey",
        "snow",
        "springgreen",
        "steelblue",
        "tan",
        "teal",
        "thistle",
        "tomato",
        "turquoise",
        "violet",
        "wheat",
        "white",
        "whitesmoke",
        "yellow",
        "yellowgreen"
      ],
      "description": "CSS named colors including transparent and currentColor"
    },
    "<css-value-containing-var()>": {
      "type": "string",
      "pattern": "^(?=.*var\\(\\s*--[^)]).+$",
      "description": "Any CSS value string containing at least one var() reference. Slot-level validation is deferred to runtime (dummy substitution / css-tree)."
    },
    "<color>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<hex-color>"
        },
        {
          "$ref": "#/definitions/<rgb-color>"
        },
        {
          "$ref": "#/definitions/<hsl-color>"
        },
        {
          "$ref": "#/definitions/<named-color>"
        }
      ],
      "description": "CSS color values supporting hex, rgb/rgba, hsl/hsla, and named colors"
    },
    "<image>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<url>"
        },
        {
          "type": "string",
          "pattern": "^(linear-gradient|radial-gradient|conic-gradient|repeating-linear-gradient|repeating-radial-gradient|repeating-conic-gradient)\\(.*\\)$",
          "description": "Gradient functions - arguments cannot be fully validated with regex"
        },
        {
          "type": "string",
          "pattern": "^image\\(.*\\)$",
          "description": "Image function - arguments cannot be fully validated with regex"
        }
      ],
      "description": "CSS image values including URLs, gradients, and image() functions"
    },
    "<position>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<position-one>"
        },
        {
          "$ref": "#/definitions/<position-two>"
        },
        {
          "$ref": "#/definitions/<position-four>"
        }
      ],
      "description": "Single position value. Full position syntax with multiple values and combinations requires complex parsing that cannot be fully validated with regex."
    },
    "<position-one>": {
      "anyOf": [
        {
          "enum": [
            "left",
            "center",
            "right",
            "top",
            "bottom",
            "x-start",
            "x-end",
            "y-start",
            "y-end",
            "block-start",
            "block-end",
            "inline-start",
            "inline-end"
          ]
        },
        {
          "$ref": "#/definitions/<positive-length-percentage>"
        }
      ]
    },
    "<position-two>": {
      "anyOf": [
        {
          "pattern": "^(((left|center|right|x-start|x-end)\\s(top|center|bottom|y-start|y-end))|((top|center|bottom|y-start|y-end)\\s(left|center|right|x-start|x-end)))$"
        },
        {
          "pattern": "^(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))$"
        },
        {
          "pattern": "^((block-start|center|block-end)\\s(inline-start|center|inline-end))|((inline-start|center|inline-end)\\s(block-start|center|block-end))$"
        },
        {
          "pattern": "^((start|center|end)\\s*){2}$"
        }
      ]
    },
    "<position-four>": {
      "anyOf": [
        {
          "pattern": "^((left|right|x-start|x-end)\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))\\s(top|bottom|y-start|y-end)\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))|((top|bottom|y-start|y-end)\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))\\s(left|right|x-start|x-end)\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))$"
        },
        {
          "pattern": "^((block-start|block-end)\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))\\s(inline-start|inline-end)\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))|((inline-start|inline-end)\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))\\s(block-start|block-end)\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))$"
        },
        {
          "pattern": "^((start|end)\\s(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))\\s*){2}$"
        }
      ]
    },
    "<transform-function>": {
      "type": "string",
      "pattern": "^(matrix|matrix3d|perspective|rotate|rotate3d|rotateX|rotateY|rotateZ|scale|scale3d|scaleX|scaleY|scaleZ|skew|skewX|skewY|translate|translate3d|translateX|translateY|translateZ)\\(.*\\)$",
      "description": "Transform functions like rotate(), translate(), scale(). Function arguments cannot be fully validated with regex as they require parsing of nested expressions."
    },
    "<var()>": {
      "type": "string",
      "pattern": "^var\\(--[^(),]+(?:,\\s?.+)?\\)$",
      "description": "CSS var() function- resolving a variable value from the variable"
    },
    "<basic-math-functions>": {
      "type": "string",
      "pattern": "^(calc|min|max|clamp|round|mod|rem|abs)\\((?!.*\\/\\s*0\\b).+\\)$",
      "description": "Basic CSS math functions that work with any value type. Percentages allowed where contextually appropriate."
    },
    "<basic-math-functions-without-percentage>": {
      "type": "string",
      "pattern": "^(calc|min|max|clamp|round|mod|rem|abs)\\((?!.*\\/\\s*0\\b)[^%]+\\)$",
      "description": "Basic CSS math functions without percentages or division by zero."
    },
    "<basic-math-functions-with-percentage>": {
      "type": "string",
      "pattern": "(calc|min|max|clamp|round|mod|rem|abs)\\([^)]*%[^)]*\\)",
      "description": "Detects if any basic math function contains percentages"
    },
    "<all-math-functions>": {
      "type": "string",
      "pattern": "^(calc|min|max|clamp|round|mod|rem|abs|sin|cos|tan|asin|acos|atan|atan2|pow|sqrt|hypot|log|exp|sign)\\((?!.*\\/\\s*0\\b).+\\)$",
      "description": "All CSS math functions - basic, trigonometric, and advanced mathematical functions."
    },
    "<all-math-functions-without-percentage>": {
      "type": "string",
      "pattern": "^(calc|min|max|clamp|round|mod|rem|abs|sin|cos|tan|asin|acos|atan|atan2|pow|sqrt|hypot|log|exp|sign)\\((?!.*\\/\\s*0\\b)(?!.*%).+\\)$",
      "description": "All CSS math functions without percentages or division by zero."
    },
    "<attr()>": {
      "type": "string",
      "pattern": "^attr\\(.*\\)$",
      "description": "CSS attr() function. Cannot fully validate fallback values and type hints with regex."
    },
    "<image-set()>": {
      "type": "string",
      "pattern": "^image-set\\(.*\\)$",
      "description": "CSS image-set() function. Cannot parse comma-separated URLs and resolution descriptors with regex."
    },
    "<basic-shape>": {
      "type": "string",
      "pattern": "^(inset|rect|xywh|circle|ellipse|polygon|path|shape)\\(.*\\)$",
      "description": "CSS basic shape functions. Shape-specific arguments cannot be fully validated with regex."
    },
    "<filter-function>": {
      "type": "string",
      "pattern": "^(blur|brightness|contrast|drop-shadow|grayscale|hue-rotate|invert|opacity|saturate|sepia|url)\\(([^\\(\\)]*|(\\([^\\(\\)]*\\)))+\\)$",
      "description": "CSS filter functions. Function arguments cannot be fully validated with regex."
    },
    "<filter-value-list>": {
      "type": "string",
      "pattern": "^((blur|brightness|contrast|drop-shadow|grayscale|hue-rotate|invert|opacity|saturate|sepia|url)\\(([^\\(\\)]*|(\\([^\\(\\)]*\\)))+\\))(\\s+(blur|brightness|contrast|drop-shadow|grayscale|hue-rotate|invert|opacity|saturate|sepia|url)\\(([^\\(\\)]*|(\\([^\\(\\)]*\\)))+\\))*$",
      "description": "CSS filter functions - value separated list. Function arguments cannot be fully validated with regex."
    },
    "<filter>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<none>"
        },
        {
          "$ref": "#/definitions/<filter-value-list>"
        }
      ],
      "description": "CSS filter value"
    },
    "<line-width>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<positive-length>"
        },
        {
          "type": "string",
          "enum": [
            "thin",
            "medium",
            "thick"
          ]
        }
      ],
      "description": "CSS line width: length values or predefined keywords"
    },
    "<line-style>": {
      "type": "string",
      "enum": [
        "none",
        "hidden",
        "dotted",
        "dashed",
        "solid",
        "double",
        "groove",
        "ridge",
        "inset",
        "outset"
      ],
      "description": "CSS line style keywords"
    },
    "<global-values>": {
      "type": "string",
      "enum": [
        "inherit",
        "initial",
        "unset",
        "revert",
        "revert-layer"
      ],
      "description": "Global values available for any CSS property"
    },
    "<flex>": {
      "type": "string",
      "pattern": "^\\d*\\.?\\d+fr$",
      "description": "CSS flex unit for grid and flexbox"
    },
    "<none>": {
      "type": "string",
      "enum": [
        "none"
      ],
      "description": "CSS none keyword"
    },
    "<normal>": {
      "type": "string",
      "enum": [
        "normal"
      ],
      "description": "CSS normal keyword"
    },
    "<shadow>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<none>"
        },
        {
          "type": "string",
          "pattern": "^(inset\\s+)?(-?\\d+\\w*\\s+){2,4}(#[a-fA-F0-9]{3,8}|rgba?\\(.*\\)|hsla?\\(.*\\)|[a-zA-Z]+)?$"
        }
      ],
      "description": "CSS shadow value (box-shadow, text-shadow). Complex syntax with optional inset, multiple length values, and color cannot be fully validated with regex."
    },
    "<font-family>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<family-name>"
        },
        {
          "$ref": "#/definitions/<generic-family>"
        },
        {
          "type": "string",
          "pattern": "^['\"]?([^\\d][\\p{L}\\s\\-_\\d]*)['\"]?(,\\s*['\"]?([^\\d][\\p{L}\\s\\-_\\d]*)['\"]?)*$",
          "description": "Complex family name with multiple family names separated by commas"
        }
      ],
      "description": "CSS font family: generic families, quoted family names, or unquoted family names"
    },
    "<font-weight>": {
      "anyOf": [
        {
          "type": "string",
          "enum": [
            "normal",
            "bold",
            "bolder",
            "lighter"
          ]
        },
        {
          "type": "string",
          "pattern": "^(100|200|300|400|500|600|700|800|900)$"
        }
      ],
      "description": "CSS font weight: keywords or numeric values"
    },
    "<font-style>": {
      "anyOf": [
        {
          "type": "string",
          "enum": [
            "normal",
            "italic",
            "oblique"
          ]
        },
        {
          "type": "string",
          "pattern": "^oblique\\s+\\d+deg$"
        }
      ],
      "description": "CSS font style: keywords or oblique with angle"
    },
    "<font-size>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<absolute-size>"
        },
        {
          "$ref": "#/definitions/<relative-size>"
        },
        {
          "$ref": "#/definitions/<positive-length-percentage>"
        },
        {
          "type": "string",
          "enum": [
            "math"
          ]
        }
      ],
      "description": "CSS font size: length, percentage, or keyword values"
    },
    "<display>": {
      "anyOf": [
        {
          "type": "string",
          "enum": [
            "table-row-group",
            "table-header-group",
            "table-footer-group",
            "table-row",
            "table-cell",
            "table-column-group",
            "table-column",
            "table-caption",
            "ruby-base",
            "ruby-text",
            "ruby-base-container",
            "ruby-text-container",
            "contents",
            "none",
            "inline-block",
            "inline-table",
            "inline-flex",
            "inline-grid"
          ]
        },
        {
          "type": "string",
          "description": "complex display value that cannot be fully validated with regex"
        }
      ],
      "description": "CSS display property values"
    },
    "<overflow-block>": {
      "type": "string",
      "enum": [
        "visible",
        "hidden",
        "clip",
        "scroll",
        "auto"
      ],
      "description": "CSS overflow-x and overflow-y property values"
    },
    "<overflow>": {
      "type": "string",
      "pattern": "^(visible|hidden|scroll|auto|clip)(\\s+(visible|hidden|scroll|auto|clip))?$",
      "description": "CSS overflow property values"
    },
    "<text-align>": {
      "type": "string",
      "enum": [
        "left",
        "right",
        "center",
        "justify",
        "start",
        "end",
        "match-parent"
      ],
      "description": "CSS text-align property values"
    },
    "<align-items>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<normal>"
        },
        {
          "type": "string",
          "enum": [
            "stretch"
          ]
        },
        {
          "$ref": "#/definitions/<baseline-position>"
        },
        {
          "type": "string",
          "pattern": "^((safe|unsafe)\\s+)?(center|start|end|self-start|self-end|flex-start|flex-end)$"
        }
      ],
      "description": "CSS align-items values"
    },
    "<vertical-align>": {
      "anyOf": [
        {
          "type": "string",
          "enum": [
            "baseline",
            "sub",
            "super",
            "text-top",
            "text-bottom",
            "middle",
            "top",
            "bottom"
          ]
        },
        {
          "$ref": "#/definitions/<length>"
        },
        {
          "$ref": "#/definitions/<percentage>"
        }
      ],
      "description": "CSS vertical-align: keywords, length, or percentage"
    },
    "<border-radius>": {
      "type": "string",
      "pattern": "^(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)\\s*){1,4}(/\\s*(0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)\\s*){1,4})?$",
      "description": "CSS border-radius shorthand. Complex syntax combining multiple radius values cannot be fully validated with regex."
    },
    "<border-top-left-radius>": {
      "type": "string",
      "pattern": "^(calc|min|max|clamp|round|mod|rem|abs\\([^,]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s+(calc|min|max|clamp|round|mod|rem|abs\\([^,]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%)))?$",
      "description": "CSS border-top-left-radius shorthand"
    },
    "<border-style>": {
      "type": "string",
      "pattern": "^(none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset)(\\s+(none|hidden|dotted|dashed|solid|double|groove|ridge|inset|outset)){0,3}$",
      "description": "CSS border-style shorthand"
    },
    "<border-width>": {
      "type": "string",
      "pattern": "^(thin|medium|thick|(calc|min|max|clamp|round|mod|rem|abs)\\([^,]+\\)|(\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))(\\s+(thin|medium|thick|(calc|min|max|clamp|round|mod|rem|abs)\\([^,]+\\)|(\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q)))){0,3}$",
      "description": "CSS border-width shorthand"
    },
    "<border>": {
      "type": "string",
      "pattern": "^(?!.*\\/\\s*0).*$",
      "description": "CSS border shorthand with division by zero rejection in calc expressions. Detailed syntax validation handled by css-tree."
    },
    "<background>": {
      "type": "string",
      "description": "CSS background shorthand. Extremely complex syntax combining multiple background layers with image, position, size, repeat, attachment, origin, clip, and color cannot be fully validated with regex."
    },
    "<transition>": {
      "type": "string",
      "description": "CSS transition shorthand. Complex syntax combining property, duration, timing-function, and delay cannot be fully validated with regex."
    },
    "<animation>": {
      "type": "string",
      "description": "CSS animation shorthand. Complex syntax combining name, duration, timing-function, delay, iteration-count, direction, fill-mode, and play-state cannot be fully validated with regex."
    },
    "<grid-template>": {
      "type": "string",
      "description": "CSS grid template properties. Complex syntax with track sizes, line names, and repeat functions cannot be fully validated with regex."
    },
    "<flex-shorthand>": {
      "type": "string",
      "description": "CSS flex shorthand combining flex-grow, flex-shrink, and flex-basis. Complex parsing required to validate the various combinations."
    },
    "<blend-mode>": {
      "type": "string",
      "enum": [
        "normal",
        "multiply",
        "screen",
        "overlay",
        "darken",
        "lighten",
        "color-dodge",
        "color-burn",
        "hard-light",
        "soft-light",
        "difference",
        "exclusion",
        "hue",
        "saturation",
        "color",
        "luminosity"
      ],
      "description": "CSS blend mode values for mix-blend-mode and background-blend-mode"
    },
    "<mix-blend-mode>": {
      "$ref": "#/definitions/<blend-mode>",
      "description": "CSS mix-blend-mode property values"
    },
    "<background-blend-mode>": {
      "$ref": "#/definitions/<blend-mode>",
      "description": "CSS background-blend-mode property values"
    },
    "<timing-function>": {
      "anyOf": [
        {
          "type": "string",
          "enum": [
            "ease",
            "ease-in",
            "ease-out",
            "ease-in-out",
            "linear",
            "step-start",
            "step-end"
          ]
        },
        {
          "type": "string",
          "pattern": "^cubic-bezier\\(\\s*-?\\d*\\.?\\d+\\s*,\\s*-?\\d*\\.?\\d+\\s*,\\s*-?\\d*\\.?\\d+\\s*,\\s*-?\\d*\\.?\\d+\\s*\\)$"
        },
        {
          "type": "string",
          "pattern": "^steps\\(\\s*\\d+\\s*(,\\s*(start|end)\\s*)?\\)$"
        }
      ],
      "description": "CSS timing function: keywords, cubic-bezier(), or steps()"
    },
    "<repeat-style>": {
      "type": "string",
      "enum": [
        "repeat",
        "repeat-x",
        "repeat-y",
        "no-repeat",
        "space",
        "round"
      ],
      "description": "CSS background-repeat values"
    },
    "<attachment>": {
      "type": "string",
      "enum": [
        "scroll",
        "fixed",
        "local"
      ],
      "description": "CSS background-attachment values"
    },
    "<origin>": {
      "type": "string",
      "enum": [
        "border-box",
        "padding-box",
        "content-box"
      ],
      "description": "CSS background-origin values"
    },
    "<clip>": {
      "type": "string",
      "enum": [
        "border-box",
        "padding-box",
        "content-box",
        "text"
      ],
      "description": "CSS background-clip values"
    },
    "<sizing>": {
      "anyOf": [
        {
          "type": "string",
          "enum": [
            "auto",
            "cover",
            "contain"
          ]
        },
        {
          "$ref": "#/definitions/<length>"
        },
        {
          "$ref": "#/definitions/<percentage>"
        }
      ],
      "description": "CSS background-size values"
    },
    "<cursor>": {
      "anyOf": [
        {
          "type": "string",
          "enum": [
            "auto",
            "default",
            "none",
            "context-menu",
            "help",
            "pointer",
            "progress",
            "wait",
            "cell",
            "crosshair",
            "text",
            "vertical-text",
            "alias",
            "copy",
            "move",
            "no-drop",
            "not-allowed",
            "grab",
            "grabbing",
            "all-scroll",
            "col-resize",
            "row-resize",
            "n-resize",
            "e-resize",
            "s-resize",
            "w-resize",
            "ne-resize",
            "nw-resize",
            "se-resize",
            "sw-resize",
            "ew-resize",
            "ns-resize",
            "nesw-resize",
            "nwse-resize",
            "zoom-in",
            "zoom-out"
          ]
        },
        {
          "$ref": "#/definitions/<url>"
        }
      ],
      "description": "CSS cursor: keywords or custom cursor URLs"
    },
    "<list-style-type>": {
      "type": "string",
      "enum": [
        "disc",
        "circle",
        "square",
        "decimal",
        "decimal-leading-zero",
        "lower-roman",
        "upper-roman",
        "lower-greek",
        "lower-latin",
        "upper-latin",
        "armenian",
        "georgian",
        "lower-alpha",
        "upper-alpha",
        "none"
      ],
      "description": "CSS list-style-type values"
    },
    "<z-index>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<auto>"
        },
        {
          "$ref": "#/definitions/<integer>"
        }
      ],
      "description": "CSS z-index: auto or integer"
    },
    "<opacity>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<number>"
        },
        {
          "$ref": "#/definitions/<percentage>"
        }
      ],
      "description": "CSS opacity: number (0-1) or percentage"
    },
    "<visibility>": {
      "type": "string",
      "enum": [
        "visible",
        "hidden",
        "collapse"
      ],
      "description": "CSS visibility values"
    },
    "<white-space>": {
      "type": "string",
      "enum": [
        "normal",
        "nowrap",
        "pre",
        "pre-wrap",
        "pre-line",
        "break-spaces"
      ],
      "description": "CSS white-space values"
    },
    "<text-decoration-line>": {
      "anyOf": [
        {
          "type": "string",
          "enum": [
            "none",
            "underline",
            "overline",
            "line-through",
            "blink"
          ],
          "description": "single value text decoration line"
        },
        {
          "type": "string",
          "pattern": "^(underline|overline|line-through|blink)(\\s+(underline|overline|line-through|blink))*$",
          "description": "multiple values text decoration line that cannot be fully validated with regex"
        }
      ],
      "description": "CSS text-decoration-line values"
    },
    "<text-decoration-style>": {
      "type": "string",
      "enum": [
        "solid",
        "double",
        "dotted",
        "dashed",
        "wavy"
      ],
      "description": "CSS text-decoration-style values"
    },
    "<text-transform>": {
      "type": "string",
      "enum": [
        "none",
        "capitalize",
        "uppercase",
        "lowercase",
        "full-width",
        "full-size-kana"
      ],
      "description": "CSS text-transform values"
    },
    "<word-wrap>": {
      "type": "string",
      "enum": [
        "normal",
        "break-word",
        "anywhere"
      ],
      "description": "CSS word-wrap/overflow-wrap values"
    },
    "<user-select>": {
      "type": "string",
      "enum": [
        "auto",
        "text",
        "none",
        "contain",
        "all"
      ],
      "description": "CSS user-select values"
    },
    "<pointer-events>": {
      "type": "string",
      "enum": [
        "auto",
        "bounding-box",
        "none",
        "visiblePainted",
        "visibleFill",
        "visibleStroke",
        "visible",
        "painted",
        "fill",
        "stroke",
        "all"
      ],
      "description": "CSS pointer-events values"
    },
    "<box-sizing>": {
      "type": "string",
      "enum": [
        "content-box",
        "border-box"
      ],
      "description": "CSS box-sizing values"
    },
    "<resize>": {
      "type": "string",
      "enum": [
        "none",
        "both",
        "horizontal",
        "vertical",
        "block",
        "inline"
      ],
      "description": "CSS resize values"
    },
    "<outline>": {
      "type": "string",
      "description": "CSS outline shorthand. Complex syntax combining outline-width, outline-style, and outline-color cannot be fully validated with regex."
    },
    "<quotes>": {
      "anyOf": [
        {
          "type": "string",
          "enum": [
            "none",
            "auto"
          ]
        },
        {
          "$ref": "#/definitions/<string>"
        }
      ],
      "description": "CSS quotes: none, auto, or quoted string pairs"
    },
    "<content>": {
      "type": "string",
      "description": "CSS content property. Complex syntax with strings, counters, attr(), and url() cannot be fully validated with regex."
    },
    "<will-change>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<auto>"
        },
        {
          "type": "string",
          "enum": [
            "scroll-position",
            "contents"
          ]
        },
        {
          "$ref": "#/definitions/<custom-ident>"
        }
      ],
      "description": "CSS will-change: auto or property names"
    },
    "<contain>": {
      "type": "string",
      "enum": [
        "none",
        "strict",
        "content",
        "size",
        "inline-size",
        "layout",
        "style",
        "paint"
      ],
      "description": "CSS contain values"
    },
    "<isolation>": {
      "type": "string",
      "enum": [
        "auto",
        "isolate"
      ],
      "description": "CSS isolation values"
    },
    "<writing-mode>": {
      "type": "string",
      "enum": [
        "horizontal-tb",
        "vertical-rl",
        "vertical-lr",
        "sideways-rl",
        "sideways-lr"
      ],
      "description": "CSS writing-mode values"
    },
    "<direction>": {
      "type": "string",
      "enum": [
        "ltr",
        "rtl"
      ],
      "description": "CSS direction values"
    },
    "<unicode-bidi>": {
      "type": "string",
      "enum": [
        "normal",
        "embed",
        "isolate",
        "bidi-override",
        "isolate-override",
        "plaintext"
      ],
      "description": "CSS unicode-bidi values"
    },
    "<object-fit>": {
      "type": "string",
      "enum": [
        "fill",
        "contain",
        "cover",
        "none",
        "scale-down"
      ],
      "description": "CSS object-fit values"
    },
    "<object-position>": {
      "$ref": "#/definitions/<position>",
      "description": "CSS object-position: similar to position."
    },
    "<scroll-behavior>": {
      "type": "string",
      "enum": [
        "auto",
        "smooth"
      ],
      "description": "CSS scroll-behavior values"
    },
    "<appearance>": {
      "type": "string",
      "enum": [
        "none",
        "auto",
        "base-select",
        "textfield",
        "searchfield",
        "textarea",
        "checkbox",
        "radio",
        "menulist",
        "menulist-button",
        "listbox",
        "meter",
        "progress-bar",
        "button"
      ],
      "description": "CSS appearance values"
    },
    "<outline-offset>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<length>"
        }
      ],
      "description": "CSS outline-offset: length values"
    },
    "<tab-size>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<integer>"
        },
        {
          "$ref": "#/definitions/<length>"
        }
      ],
      "description": "CSS tab-size: integer or length"
    },
    "<hyphens>": {
      "type": "string",
      "enum": [
        "none",
        "manual",
        "auto"
      ],
      "description": "CSS hyphens values"
    },
    "<word-break>": {
      "type": "string",
      "enum": [
        "normal",
        "break-all",
        "keep-all",
        "break-word"
      ],
      "description": "CSS word-break values"
    },
    "<line-break>": {
      "type": "string",
      "enum": [
        "auto",
        "loose",
        "normal",
        "strict",
        "anywhere"
      ],
      "description": "CSS line-break values"
    },
    "<letter-spacing>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<normal>"
        },
        {
          "$ref": "#/definitions/<length>"
        }
      ],
      "description": "CSS letter-spacing: normal or length"
    },
    "<word-spacing>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<normal>"
        },
        {
          "$ref": "#/definitions/<length>"
        }
      ],
      "description": "CSS word-spacing: normal, length, or percentage"
    },
    "<line-height>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<normal>"
        },
        {
          "$ref": "#/definitions/<positive-number>"
        },
        {
          "$ref": "#/definitions/<positive-length-percentage>"
        }
      ],
      "description": "CSS line-height: normal, number, length, or percentage"
    },
    "<text-indent>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<length-percentage>"
        },
        {
          "type": "string",
          "pattern": "(?:^((calc|min|max|clamp|round|mod|rem|abs)\\([^,]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(?=(?:\\shanging|\\seach-line){0,2}$))|(?:^(?:hanging\\s?|each-line\\s?){1,2}\\s((calc|min|max|clamp|round|mod|rem|abs)\\([^,]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))\\s?(?:hanging|each-line)?$)",
          "description": "css text-indent string"
        }
      ],
      "description": "CSS text-indent: length or percentage, with optional 'hanging' or 'each-line' keywords"
    },
    "<text-overflow>": {
      "type": "string",
      "enum": [
        "clip",
        "ellipsis"
      ],
      "description": "CSS text-overflow values"
    },
    "<text-decoration>": {
      "type": "string",
      "description": "CSS text-decoration shorthand. Complex syntax combining text-decoration-line, text-decoration-style, text-decoration-color, and text-decoration-thickness cannot be fully validated with regex."
    },
    "<text-shadow>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<none>"
        },
        {
          "type": "string",
          "not": {
            "$ref": "#/definitions/<basic-math-functions-with-percentage>"
          }
        }
      ],
      "description": "CSS text-shadow: complex shadow value cannot be fully validated with regex"
    },
    "<box-shadow>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<none>"
        },
        {
          "type": "string",
          "not": {
            "$ref": "#/definitions/<basic-math-functions-with-percentage>"
          },
          "description": "complex shadow value that cannot be fully validated with regex"
        }
      ],
      "description": "CSS box-shadow: none or shadow values (h-offset v-offset take <length>, no percentages allowed)"
    },
    "<list-style>": {
      "type": "string",
      "description": "CSS list-style shorthand. Complex syntax combining list-style-type, list-style-position, and list-style-image cannot be fully validated with regex."
    },
    "<list-style-position>": {
      "type": "string",
      "enum": [
        "inside",
        "outside"
      ],
      "description": "CSS list-style-position values"
    },
    "<list-style-image>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<none>"
        },
        {
          "$ref": "#/definitions/<image>"
        }
      ],
      "description": "CSS list-style-image: none or URL"
    },
    "<alpha-value>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<number>"
        },
        {
          "$ref": "#/definitions/<percentage>"
        }
      ],
      "description": "CSS alpha value for colors: number (0-1) or percentage"
    },
    "<absolute-size>": {
      "type": "string",
      "enum": [
        "xx-small",
        "x-small",
        "small",
        "medium",
        "large",
        "x-large",
        "xx-large",
        "xxx-large"
      ],
      "description": "CSS absolute font sizes"
    },
    "<relative-size>": {
      "type": "string",
      "enum": [
        "larger",
        "smaller"
      ],
      "description": "CSS relative font sizes"
    },
    "<angle-percentage>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<angle>"
        },
        {
          "$ref": "#/definitions/<percentage>"
        }
      ],
      "description": "CSS angle or percentage"
    },
    "<number-percentage>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<number>"
        },
        {
          "$ref": "#/definitions/<percentage>"
        }
      ],
      "description": "CSS number or percentage"
    },
    "<time-percentage>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<time>"
        },
        {
          "$ref": "#/definitions/<percentage>"
        }
      ],
      "description": "CSS time or percentage"
    },
    "<frequency-percentage>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<frequency>"
        },
        {
          "$ref": "#/definitions/<percentage>"
        }
      ],
      "description": "CSS frequency or percentage"
    },
    "<baseline-position>": {
      "type": "string",
      "pattern": "^(first\\s+baseline|last\\s+baseline|baseline)$",
      "description": "CSS baseline position: baseline, first baseline, or last baseline"
    },
    "<content-distribution>": {
      "type": "string",
      "enum": [
        "space-between",
        "space-around",
        "space-evenly",
        "stretch"
      ],
      "description": "CSS content distribution values for alignment"
    },
    "<content-position>": {
      "type": "string",
      "enum": [
        "center",
        "start",
        "end",
        "flex-start",
        "flex-end"
      ],
      "description": "CSS content position values for alignment"
    },
    "<self-position>": {
      "type": "string",
      "enum": [
        "center",
        "start",
        "end",
        "self-start",
        "self-end",
        "flex-start",
        "flex-end"
      ],
      "description": "CSS self position values for alignment"
    },
    "<overflow-position>": {
      "type": "string",
      "enum": [
        "unsafe",
        "safe"
      ],
      "description": "CSS overflow position modifiers"
    },
    "<justify-content>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<normal>"
        },
        {
          "$ref": "#/definitions/<content-distribution>"
        },
        {
          "$ref": "#/definitions/<content-position>"
        },
        {
          "type": "string",
          "enum": [
            "left",
            "right"
          ]
        },
        {
          "type": "string",
          "pattern": "^(safe|unsafe)?\\s+(left|right|center|start|end|flex-start|flex-end)$"
        }
      ],
      "description": "CSS justify-content values"
    },
    "<visual-box>": {
      "type": "string",
      "enum": [
        "content-box",
        "padding-box",
        "border-box"
      ],
      "description": "CSS visual box types"
    },
    "<shape-box>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<visual-box>"
        },
        {
          "type": "string",
          "enum": [
            "margin-box"
          ]
        }
      ],
      "description": "CSS shape box types"
    },
    "<geometry-box>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<shape-box>"
        },
        {
          "type": "string",
          "enum": [
            "fill-box",
            "stroke-box",
            "view-box"
          ]
        }
      ],
      "description": "CSS geometry box types including visual box and additional geometry boxes"
    },
    "<paint-box>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<visual-box>"
        },
        {
          "type": "string",
          "enum": [
            "fill-box",
            "stroke-box"
          ]
        }
      ],
      "description": "CSS paint box types"
    },
    "<coord-box>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<paint-box>"
        },
        {
          "type": "string",
          "enum": [
            "view-box"
          ]
        }
      ],
      "description": "CSS coordinate box types (paint-box or view-box)"
    },
    "<mask-clip>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<coord-box>"
        },
        {
          "type": "string",
          "enum": [
            "no-clip"
          ]
        }
      ],
      "description": "CSS mask-clip values including coord-box and no-clip"
    },
    "<mask-origin>": {
      "$ref": "#/definitions/<coord-box>",
      "description": "CSS mask-origin values (coord-box)"
    },
    "<generic-family>": {
      "type": "string",
      "enum": [
        "serif",
        "sans-serif",
        "monospace",
        "cursive",
        "fantasy",
        "system-ui",
        "ui-serif",
        "ui-sans-serif",
        "ui-monospace",
        "ui-rounded",
        "math",
        "emoji",
        "fangsong"
      ],
      "description": "CSS generic font families"
    },
    "<family-name>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<string>"
        },
        {
          "$ref": "#/definitions/<custom-ident>"
        }
      ],
      "description": "CSS font family name: quoted string or unquoted identifier"
    },
    "<system-family-name>": {
      "type": "string",
      "enum": [
        "caption",
        "icon",
        "menu",
        "message-box",
        "small-caption",
        "status-bar"
      ],
      "description": "CSS system font family names"
    },
    "<font-stretch-absolute>": {
      "anyOf": [
        {
          "type": "string",
          "enum": [
            "normal",
            "ultra-condensed",
            "extra-condensed",
            "condensed",
            "semi-condensed",
            "semi-expanded",
            "expanded",
            "extra-expanded",
            "ultra-expanded"
          ]
        },
        {
          "$ref": "#/definitions/<percentage>"
        }
      ],
      "description": "CSS font stretch absolute values"
    },
    "<font-weight-absolute>": {
      "anyOf": [
        {
          "type": "string",
          "enum": [
            "normal",
            "bold"
          ]
        },
        {
          "type": "string",
          "pattern": "^(100|200|300|400|500|600|700|800|900|[1-9][0-9]{0,2})$"
        }
      ],
      "description": "CSS font weight absolute values: normal, bold, or number 1-1000"
    },
    "<grid-line>": {
      "type": "string",
      "description": "CSS grid line: auto, custom identifier, integer with optional identifier, or span notation. Complex syntax cannot be fully validated with regex."
    },
    "<track-breadth>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<length-percentage>"
        },
        {
          "$ref": "#/definitions/<flex>"
        },
        {
          "type": "string",
          "enum": [
            "min-content",
            "max-content",
            "auto"
          ]
        }
      ],
      "description": "CSS grid track breadth"
    },
    "<inflexible-breadth>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<length-percentage>"
        },
        {
          "type": "string",
          "enum": [
            "min-content",
            "max-content",
            "auto"
          ]
        }
      ],
      "description": "CSS inflexible breadth (track breadth without flex)"
    },
    "<track-size>": {
      "type": "string",
      "description": "CSS grid track size: track-breadth, minmax(), or fit-content(). Complex syntax cannot be fully validated with regex."
    },
    "<easing-function>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<timing-function>"
        },
        {
          "type": "string",
          "pattern": "^linear\\(.*\\)$",
          "description": "Linear easing function - arguments cannot be fully validated with regex"
        },
        {
          "type": "string",
          "pattern": "^steps\\(\\s*\\d+\\s*(,\\s*(start|end|jump-start|jump-end|jump-none|jump-both)\\s*)?\\)$"
        }
      ],
      "description": "CSS easing functions including cubic-bezier, steps, and linear"
    },
    "<single-animation-direction>": {
      "type": "string",
      "enum": [
        "normal",
        "reverse",
        "alternate",
        "alternate-reverse"
      ],
      "description": "CSS animation direction values"
    },
    "<single-animation-fill-mode>": {
      "type": "string",
      "enum": [
        "none",
        "forwards",
        "backwards",
        "both"
      ],
      "description": "CSS animation fill mode values"
    },
    "<single-animation-play-state>": {
      "type": "string",
      "enum": [
        "running",
        "paused"
      ],
      "description": "CSS animation play state values"
    },
    "<single-animation-iteration-count>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<number>"
        },
        {
          "type": "string",
          "enum": [
            "infinite"
          ]
        }
      ],
      "description": "CSS animation iteration count: number or infinite"
    },
    "<keyframes-name>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<custom-ident>"
        },
        {
          "$ref": "#/definitions/<string>"
        }
      ],
      "description": "CSS keyframes name: identifier or string"
    },
    "<single-transition-property>": {
      "anyOf": [
        {
          "type": "string",
          "enum": [
            "all"
          ]
        },
        {
          "$ref": "#/definitions/<custom-ident>"
        }
      ],
      "description": "CSS transition property: all or property name"
    },
    "<quote>": {
      "type": "string",
      "enum": [
        "open-quote",
        "close-quote",
        "no-open-quote",
        "no-close-quote"
      ],
      "description": "CSS quote values for generated content"
    },
    "<counter-style-name>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<custom-ident>"
        },
        {
          "type": "string",
          "enum": [
            "decimal",
            "decimal-leading-zero",
            "lower-roman",
            "upper-roman",
            "lower-greek",
            "lower-latin",
            "upper-latin",
            "armenian",
            "georgian",
            "lower-alpha",
            "upper-alpha",
            "disc",
            "circle",
            "square",
            "none"
          ]
        }
      ],
      "description": "CSS counter style: predefined or custom identifier"
    },
    "<ratio>": {
      "type": "string",
      "pattern": "^\\d+(\\.\\d+)?\\s*/\\s*\\d+(\\.\\d+)?$",
      "description": "CSS ratio: number/number"
    },
    "<dasharray>": {
      "type": "string",
      "description": "CSS dash array for stroke-dasharray. Complex syntax with multiple length/percentage/number values cannot be fully validated with regex."
    },
    "<paint>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<none>"
        },
        {
          "$ref": "#/definitions/<color>"
        },
        {
          "$ref": "#/definitions/<url>"
        }
      ],
      "description": "CSS paint values for SVG: none, color, URL, or context keywords"
    },
    "<overflow-wrap>": {
      "type": "string",
      "enum": [
        "normal",
        "break-word",
        "anywhere"
      ],
      "description": "CSS overflow-wrap values (same as word-wrap)"
    },
    "<text-decoration-thickness>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<auto>"
        },
        {
          "$ref": "#/definitions/<positive-length>"
        },
        {
          "$ref": "#/definitions/<positive-percentage>"
        },
        {
          "type": "string",
          "enum": [
            "from-font"
          ]
        }
      ],
      "description": "CSS text decoration thickness"
    },
    "<text-underline-offset>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<auto>"
        },
        {
          "$ref": "#/definitions/<length>"
        },
        {
          "$ref": "#/definitions/<percentage>"
        }
      ],
      "description": "CSS text underline offset"
    },
    "<text-emphasis-style>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<none>"
        },
        {
          "type": "string",
          "enum": [
            "filled",
            "open",
            "dot",
            "circle",
            "double-circle",
            "triangle",
            "sesame"
          ]
        },
        {
          "$ref": "#/definitions/<string>"
        }
      ],
      "description": "CSS text emphasis style"
    },
    "<mask-composite>": {
      "type": "string",
      "enum": [
        "add",
        "subtract",
        "intersect",
        "exclude"
      ],
      "description": "CSS mask composite operation values"
    },
    "<mask-mode>": {
      "type": "string",
      "enum": [
        "alpha",
        "luminance",
        "match-source"
      ],
      "description": "CSS mask mode values"
    },
    "<clip-path>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<none>"
        },
        {
          "$ref": "#/definitions/<url>"
        },
        {
          "$ref": "#/definitions/<basic-shape>"
        }
      ],
      "description": "CSS clip-path: none, URL, or basic shape"
    },
    "<shape-outside>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<none>"
        },
        {
          "$ref": "#/definitions/<image>"
        },
        {
          "$ref": "#/definitions/<basic-shape>"
        }
      ],
      "description": "CSS shape-outside: none, image, or basic shape"
    },
    "<intrinsic-size-keyword>": {
      "type": "string",
      "enum": [
        "auto",
        "min-content",
        "max-content",
        "fit-content"
      ],
      "description": "CSS intrinsic sizing keywords"
    },
    "<step-position>": {
      "type": "string",
      "enum": [
        "jump-start",
        "jump-end",
        "jump-none",
        "jump-both",
        "start",
        "end"
      ],
      "description": "CSS step position for steps() timing function"
    },
    "<system-color>": {
      "type": "string",
      "enum": [
        "AccentColor",
        "AccentColorText",
        "ActiveText",
        "ButtonBorder",
        "ButtonFace",
        "ButtonText",
        "Canvas",
        "CanvasText",
        "Field",
        "FieldText",
        "GrayText",
        "Highlight",
        "HighlightText",
        "LinkText",
        "Mark",
        "MarkText",
        "SelectedItem",
        "SelectedItemText",
        "VisitedText"
      ],
      "description": "CSS system colors"
    },
    "<deprecated-system-color>": {
      "type": "string",
      "enum": [
        "ActiveBorder",
        "ActiveCaption",
        "AppWorkspace",
        "Background",
        "ButtonHighlight",
        "ButtonShadow",
        "CaptionText",
        "InactiveBorder",
        "InactiveCaption",
        "InactiveCaptionText",
        "InfoBackground",
        "InfoText",
        "Menu",
        "MenuText",
        "Scrollbar",
        "ThreeDDarkShadow",
        "ThreeDFace",
        "ThreeDHighlight",
        "ThreeDLightShadow",
        "ThreeDShadow",
        "Window",
        "WindowFrame",
        "WindowText"
      ],
      "description": "CSS deprecated system colors"
    },
    "<bg-size>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<positive-length-percentage>"
        },
        {
          "type": "string",
          "enum": [
            "auto",
            "cover",
            "contain"
          ]
        },
        {
          "type": "string",
          "pattern": "^(auto|calc|min|max|clamp|round|mod|rem|abs\\([^,]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s+(auto|calc|min|max|clamp|round|mod|rem|abs\\([^,]+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))?)$",
          "description": "complex syntax with multiple values that cannot be fully validated with regex"
        }
      ],
      "description": "CSS background-size values"
    },
    "<bg-position>": {
      "type": "string",
      "description": "CSS background-position values. Complex syntax with multiple position values and combinations cannot be fully validated with regex."
    },
    "<bg-clip>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<visual-box>"
        },
        {
          "type": "string",
          "enum": [
            "text"
          ]
        }
      ],
      "description": "CSS background-clip values"
    },
    "<bg-image>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<none>"
        },
        {
          "$ref": "#/definitions/<image>"
        }
      ],
      "description": "CSS background-image values"
    },
    "<hue>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<number>"
        },
        {
          "$ref": "#/definitions/<angle>"
        }
      ],
      "description": "CSS hue value: number or angle"
    },
    "<radial-shape>": {
      "type": "string",
      "enum": [
        "circle",
        "ellipse"
      ],
      "description": "CSS radial gradient shape"
    },
    "<radial-extent>": {
      "type": "string",
      "enum": [
        "closest-corner",
        "closest-side",
        "farthest-corner",
        "farthest-side"
      ],
      "description": "CSS radial gradient extent"
    },
    "<side-or-corner>": {
      "type": "string",
      "pattern": "^(left|right|top|bottom)$|^(left|right)\\s+(top|bottom)$|^(top|bottom)\\s+(left|right)$",
      "description": "CSS gradient side or corner direction"
    },
    "<color-stop-length>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<length-percentage>"
        },
        {
          "type": "string",
          "pattern": "^\\d+(\\.\\d+)?%\\s+\\d+(\\.\\d+)?%$"
        }
      ],
      "description": "CSS color stop length: single or double length-percentage"
    },
    "<color-stop-angle>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<angle-percentage>"
        },
        {
          "type": "string",
          "pattern": "^\\d+(\\.\\d+)?deg\\s+\\d+(\\.\\d+)?deg$"
        }
      ],
      "description": "CSS color stop angle: single or double angle-percentage"
    },
    "<masking-mode>": {
      "type": "string",
      "enum": [
        "alpha",
        "luminance",
        "match-source"
      ],
      "description": "CSS masking mode values"
    },
    "<mask-reference>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<none>"
        },
        {
          "$ref": "#/definitions/<image>"
        },
        {
          "$ref": "#/definitions/<url>"
        }
      ],
      "description": "CSS mask reference values"
    },
    "<mask>": {
      "type": "string",
      "description": "CSS mask shorthand. Complex syntax combining multiple mask layers with mask-image, mask-mode, mask-position, mask-size, mask-repeat, mask-origin, mask-clip, and mask-composite cannot be fully validated with regex."
    },
    "<outline-line-style>": {
      "type": "string",
      "enum": [
        "none",
        "dotted",
        "dashed",
        "solid",
        "double",
        "groove",
        "ridge",
        "inset",
        "outset"
      ],
      "description": "CSS outline line style values"
    },
    "<counter-name>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<custom-ident>"
        },
        {
          "type": "string",
          "enum": [
            "list-item"
          ]
        }
      ],
      "description": "CSS counter name: custom identifier or list-item"
    },
    "<symbol>": {
      "anyOf": [
        {
          "$ref": "#/definitions/<string>"
        },
        {
          "$ref": "#/definitions/<image>"
        },
        {
          "$ref": "#/definitions/<custom-ident>"
        }
      ],
      "description": "CSS symbol values for counters"
    },
    "<symbols-type>": {
      "type": "string",
      "enum": [
        "cyclic",
        "numeric",
        "alphabetic",
        "symbolic",
        "fixed"
      ],
      "description": "CSS symbols() function type"
    },
    "<feature-tag-value>": {
      "type": "string",
      "description": "CSS font feature tag value. Complex syntax with string and optional integer/keyword cannot be fully validated with regex."
    },
    "<east-asian-variant-values>": {
      "type": "string",
      "enum": [
        "jis78",
        "jis83",
        "jis90",
        "jis04",
        "simplified",
        "traditional"
      ],
      "description": "CSS East Asian variant values"
    },
    "<east-asian-width-values>": {
      "type": "string",
      "enum": [
        "full-width",
        "proportional-width"
      ],
      "description": "CSS East Asian width values"
    },
    "<numeric-figure-values>": {
      "type": "string",
      "enum": [
        "lining-nums",
        "oldstyle-nums"
      ],
      "description": "CSS numeric figure values"
    },
    "<numeric-fraction-values>": {
      "type": "string",
      "enum": [
        "diagonal-fractions",
        "stacked-fractions"
      ],
      "description": "CSS numeric fraction values"
    },
    "<numeric-spacing-values>": {
      "type": "string",
      "enum": [
        "proportional-nums",
        "tabular-nums"
      ],
      "description": "CSS numeric spacing values"
    },
    "<common-lig-values>": {
      "type": "string",
      "enum": [
        "common-ligatures",
        "no-common-ligatures"
      ],
      "description": "CSS common ligature values"
    },
    "<discretionary-lig-values>": {
      "type": "string",
      "enum": [
        "discretionary-ligatures",
        "no-discretionary-ligatures"
      ],
      "description": "CSS discretionary ligature values"
    },
    "<historical-lig-values>": {
      "type": "string",
      "enum": [
        "historical-ligatures",
        "no-historical-ligatures"
      ],
      "description": "CSS historical ligature values"
    },
    "<contextual-alt-values>": {
      "type": "string",
      "enum": [
        "contextual",
        "no-contextual"
      ],
      "description": "CSS contextual alternates values"
    },
    "<composite-style>": {
      "type": "string",
      "enum": [
        "clear",
        "copy",
        "source-over",
        "source-in",
        "source-out",
        "source-atop",
        "destination-over",
        "destination-in",
        "destination-out",
        "destination-atop",
        "xor"
      ],
      "description": "CSS composite style values"
    },
    "<compositing-operator>": {
      "type": "string",
      "enum": [
        "add",
        "subtract",
        "intersect",
        "exclude"
      ],
      "description": "CSS compositing operator values"
    },
    "<axis>": {
      "type": "string",
      "enum": [
        "block",
        "inline",
        "x",
        "y"
      ],
      "description": "CSS axis values"
    },
    "<scroller>": {
      "type": "string",
      "enum": [
        "root",
        "nearest",
        "self"
      ],
      "description": "CSS scroller values"
    },
    "<try-size>": {
      "type": "string",
      "enum": [
        "most-width",
        "most-height",
        "most-block-size",
        "most-inline-size"
      ],
      "description": "CSS try size values"
    },
    "<try-tactic>": {
      "type": "string",
      "enum": [
        "flip-block",
        "flip-inline",
        "flip-start"
      ],
      "description": "CSS try tactic values"
    },
    "<font>": {
      "type": "string",
      "description": "CSS font shorthand. Complex syntax combining font-style, font-variant, font-weight, font-size/line-height, and font-family cannot be fully validated with regex."
    },
    "<font-variant>": {
      "type": "string",
      "description": "CSS font-variant shorthand. Complex syntax combining normal, small-caps, and various feature values cannot be fully validated with regex."
    },
    "<flex-direction>": {
      "type": "string",
      "enum": [
        "row",
        "row-reverse",
        "column",
        "column-reverse"
      ],
      "description": "CSS flex-direction values"
    },
    "<gap>": {
      "type": "string",
      "pattern": "^(normal|0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d*\\.?\\d+(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))(\\s|$){1,2}",
      "description": "CSS gap values"
    },
    "<padding>": {
      "type": "string",
      "pattern": "^((0|(calc|min|max|clamp|round|mod|rem|abs)\\(.+\\)|\\d+(\\.\\d+)?(px|spx|em|ex|ch|rem|lh|rlh|vw|vh|vmin|vmax|cm|mm|in|pt|pc|q|%))\\s*){1,4}$",
      "description": "CSS padding values"
    },
    "<padding-top>": {
      "$ref": "#/definitions/<positive-length-percentage>",
      "description": "CSS padding-top values"
    }
  }
}
